import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19 10v8.545C19 21.34 24 23 24 23s5-1.66 5-4.455V10z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M23.307 13.365v3.46H19v1.406h4.307v4.502L24 23l.693-.267V18.23H29v-1.405h-4.307v-3.461H29V10H19v3.365z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M22.28 11.138c0 .147.099.276.241.314l.566.15a.5.5 0 0 0 .245.002l2.456-.592.08-.012.6-.04a.18.18 0 1 0-.054-.357l-1.93.463a.5.5 0 0 1-.27-.01l-.34-.11a.29.29 0 0 0-.29.07.29.29 0 0 1-.424-.02l-.189-.227a.1.1 0 0 1-.026-.073c0-.119.16-.158.215-.053l.004.009c.026.05.084.073.137.056l.49-.153a.5.5 0 0 1 .284-.004l.546.152a.5.5 0 0 0 .245.007l1.812-.41a.5.5 0 0 1 .48.15l.163.178a.343.343 0 0 1-.133.553l-.136.051a.264.264 0 0 0 .093.51h.438a.5.5 0 0 1 .436.256l.087.155a.496.496 0 0 1-.227.694l-.103.048a.2.2 0 0 1-.142.009l-.078-.025a.172.172 0 0 1-.005-.326.172.172 0 0 0 .085-.26l-.004-.006a.18.18 0 0 0-.184-.072l-.491.11a.5.5 0 0 1-.174.007l-.768-.102a.145.145 0 0 0-.143.218.145.145 0 0 1-.057.204l-.774.403a.5.5 0 0 1-.332.046l-.289-.06a.32.32 0 0 1-.257-.316c0-.2-.179-.351-.376-.319l-1.263.21-.082.007h-.94a.5.5 0 0 0-.262.074l-.518.316a.5.5 0 0 1-.425.046l-.616-.214a.357.357 0 1 1 .365-.596l.194.186a.425.425 0 0 0 .716-.355l-.02-.176a.5.5 0 0 0-.274-.39l-.197-.1a.42.42 0 0 0-.368-.002l-.092.044a.275.275 0 0 1-.247-.49l.161-.085a.4.4 0 0 1 .293-.034l.582.151a.5.5 0 0 0 .57-.255l.1-.193a.14.14 0 0 0 .015-.065v-.025c0-.12.148-.18.23-.092.04.043.104.054.156.029l.072-.035a.22.22 0 0 1 .314.156l.015.077a.11.11 0 0 0 .088.086.108.108 0 0 1 .029.204l-.036.017a.12.12 0 0 0-.067.108z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagFji = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagFji_default = SvgFlagFji;

export { FlagFji_default as default };
